import { CommonUtility } from '@utility/common';

export const IntegrationType = {
  manual: 'manual',
  custom3PL: 'custom3PL',
  '3pl': '3pl',
  lyb: 'lyb',
  tactical_logistics: 'tactical',
  tactical3pl: 'tactical3pl',
  deliverr: 'deliverr',
  logistics_plus: 'logistics_plus',
  spapi: 'spapi',
  mintsoft: 'mintsoft',
  goodCang: 'goodCang',
  santaFe: 'santaFe',
  shipHero: 'shiphero',
  skudrop: 'skudrop',
  camelot: 'camelot',
  awd: 'awd',
  apiFtp: 'api/ftp',
  farfill: 'farfill',
  fbam: 'fba_m',
  skupreme: 'skupreme',
};

export const quantityTypeOptions = [
  { value: 'unit', name: 'unit', text: 'Unit' },
  { value: 'cartons', name: 'cartons', text: 'Carton' },
];

export const IntegrationTypeIcons = {
  [IntegrationType['3pl']]:
    'https://cdn.skupreme.com/public/integrations/3pl.png',
  [IntegrationType.deliverr]:
    'https://cdn.skupreme.com/public/integrations/deliverr.png',
  [IntegrationType.logistics_plus]:
    'https://cdn.skupreme.com/public/integrations/logistics_plus.png',
  [IntegrationType.spapi]:
    'https://cdn.skupreme.com/public/integrations/spapi.png',
  [IntegrationType.mintsoft]:
    'https://cdn.skupreme.com/public/integrations/mintsoft.png',
  [IntegrationType.santaFe]:
    'https://cdn.skupreme.com/public/integrations/sff.png',
  [IntegrationType.shipHero]:
    'https://cdn.skupreme.com/public/integrations/shiphero.png',
  [IntegrationType.skudrop]:
    'https://cdn.skupreme.com/public/integrations/skudrop.png',
  [IntegrationType.tactical3pl]: '/images/fp/tactical.svg',
  [IntegrationType.manual]: '/images/fp/manualDark.svg',
  default: 'https://cdn.skupreme.com/public/integrations/default.png',
};

/** The logo of an integration type; none (not the default mark) for a type without its own. */
export const integrationTypeIcon = (type?: string | null) =>
  type && type !== 'default' && Object.hasOwn(IntegrationTypeIcons, type)
    ? (IntegrationTypeIcons as Readonly<Record<string, string>>)[type]
    : undefined;

//* Note: Keeping Manual First And Other Options Sorted by Alphabetically
export const IntegrationOptions = [
  {
    text: 'Manage My Own Warehouse',
    value: IntegrationType.manual,
  },
  {
    text: 'Camelot',
    value: IntegrationType.camelot,
  },
  {
    text: 'Deliverr, Inc.',
    value: IntegrationType.deliverr,
  },
  {
    text: 'Extensiv',
    value: IntegrationType['3pl'],
  },
  {
    text: 'Mintsoft',
    value: IntegrationType.mintsoft,
  },
  {
    text: 'Santa Fe Fulfillment',
    value: IntegrationType.santaFe,
  },
  {
    text: 'ShipHero',
    value: IntegrationType.shipHero,
  },
  {
    text: 'SKUdrop',
    value: IntegrationType.skudrop,
  },
  {
    text: 'Tactical Logistics',
    value: IntegrationType.tactical_logistics,
  },
  {
    text: 'GOODCANG',
    value: IntegrationType.goodCang,
  },
];

export const getProviderIntegrationName = (integration_type?: string) => {
  if (!integration_type) {
    return '';
  }

  switch (integration_type.toLowerCase()) {
    case 'fba':
    case 'spapi':
      return 'FBA';
    case 'manual':
      return 'Manual';
    case 'api/ftp':
      return '3PL';
    case 'awd':
      return 'AWD';
    case 'wfs':
      return 'WFS';
    case 'fba_m':
      return 'FBA M';
    default:
      return (
        IntegrationOptions.find(d => d.value === integration_type)?.text ??
        CommonUtility.removeUnderscoreAndCapitalize(integration_type)
      );
  }
};
